/* eslint-disable import/prefer-default-export */

export const statesCodesColor = {
  not_received: '#99CCFF',
  received: '#FF9933',
  check_in_progress: '#E8D100',
  blocked: '#FF0000',
  checked: '#00FF00',
  cancelled: '#C0C0C0'
};
